module.exports = __webpack_public_path__ + "img/ring_y_0_1_null@2x.d794e4d3.png";